var app = angular.module('directives.googlePay');

app.directive('googlePay', [
    'configs',
    '$state',
    'ClientCards',
    'AmountCommission',
    function(configs, $state, ClientCards, $scope, AmountCommission) {
        return {
            restrict: "E",
            scope: {
                onlyGetCardData: '=',
                isDisabled: '=',
                isInvalid: '=',
                onInvalidClick: '&'
            },
            template: require('../templates/index.html'),
            controller: 'googlePayCtrl',
            link: function(scope, element, attrs, ctrl) {
            }
        }
    }
]);

app.controller('googlePayCtrl', function ($rootScope, $scope, Pay, $timeout, ClientCards, AmountCommission) {

    $scope.pay = Pay;
    $scope.environment = 'PRODUCTION';
    // $scope.environment = 'TEST';
    $scope.paymentsClient = null;
    $scope.isLoadBtn = true;
    $scope.paymentRequest = {
        apiVersion: 2,
        apiVersionMinor: 0,
        allowedPaymentMethods: [
            {
                type: 'CARD',
                parameters: {
                    allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
                    allowedCardNetworks: ['VISA', 'MASTERCARD'],
                },
                tokenizationSpecification: {
                    type: 'PAYMENT_GATEWAY',
                    parameters: {
                        gateway: 'payhub',
                        gatewayMerchantId: 'bc55a526-4ec1-47d7-b2c6-da0ef48facde',
                    },
                },
            },
        ],
        merchantInfo: {
            merchantId: 'BCR2DN6TW727VOJP', //seller(service) ID
            merchantName: 'ПУМБ',
        },
        transactionInfo: {
            countryCode: 'UA',
            currencyCode: 'UAH',
            totalPriceStatus: 'FINAL',
            totalPrice: ''+($scope.pay.amountWithCommission || $scope.pay.amountInput || 0),
            totalPriceLabel: 'Total',
        },
        callbackIntents: [],
    };

    $timeout(function () {
        onGooglePayLoaded();
    }, 2000);

    var onGooglePayLoaded = function () {
        var paymentsClient = $scope.getGooglePaymentsClient();
        paymentsClient.isReadyToPay($scope.getGoogleIsReadyToPayRequest()).then(function (response){
            if (response.result) {
                $scope.isLoadBtn = true;
                ClientCards.data.googlePayAvailable = true;
            } else {
                $scope.isLoadBtn = false;
                ClientCards.data.googlePayAvailable = false;
            }
        })
            .catch(function (err) {
                $scope.isLoadBtn = false;
                console.error(err);
            });
    }

    $scope.getGoogleIsReadyToPayRequest = function () {
        return {
            apiVersion: $scope.paymentRequest.apiVersion,
            apiVersionMinor: $scope.paymentRequest.apiVersionMinor,
            allowedPaymentMethods: $scope.paymentRequest.allowedPaymentMethods,
        };
    }

    $scope.getGooglePaymentsClient = function () {
        if ($scope.paymentsClient === null) {
            var paymentOption = {
                environment: $scope.environment,
                paymentDataCallbacks: {},
            };

            if ($scope.environment === 'PRODUCTION') {
                paymentOption['merchantInfo'] = $scope.paymentRequest.merchantInfo;
            }

            $scope.paymentsClient = new google.payments.api.PaymentsClient(paymentOption)
        }
        return $scope.paymentsClient;
    }

    $scope.onGooglePaymentButtonClicked = function () {
        if($scope.isInvalid) {
            return $scope.onInvalidClick();
        }

        $scope.paymentRequest = {
            apiVersion: 2,
            apiVersionMinor: 0,
            allowedPaymentMethods: [
                {
                    type: 'CARD',
                    parameters: {
                        allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
                        allowedCardNetworks: ['VISA', 'MASTERCARD'],
                    },
                    tokenizationSpecification: {
                        type: 'PAYMENT_GATEWAY',
                        parameters: {
                            gateway: 'payhub',
                            gatewayMerchantId: 'ac3ff393-1516-47a9-879c-b50a7f148e89',
                            // gatewayMerchantId: $scope.pay.service.id,
                        },
                    },
                },
            ],
            merchantInfo: {
                merchantId: 'BCR2DN6TW727VOJP', //seller(service) ID
                // merchantId: '12345678901234567890', //seller(service) ID
                merchantName: 'ПУМБ',
            },
            transactionInfo: {
                countryCode: 'UA',
                currencyCode: 'UAH',
                totalPriceStatus: 'FINAL',
                totalPrice: ''+($scope.pay.amountWithCommission || $scope.pay.amountInput || 0),
                totalPriceLabel: 'Total',
            },
            callbackIntents: [],
        };

        var paymentsClient = $scope.getGooglePaymentsClient();

        paymentsClient.loadPaymentData($scope.paymentRequest).then( function(paymentData) {
            ClientCards.setGAPay('GOOGLE_PAYLOAD', btoa(paymentData.paymentMethodData.tokenizationData.token));
            console.log('paymentData.paymentMethodData', paymentData.paymentMethodData);//TODO: Delete
            if($scope.onlyGetCardData) {
                $timeout(function () {
                    ClientCards.gaPayData.cardPaymentNetwork = paymentData.paymentMethodData.info.cardNetwork;
                    ClientCards.gaPayData.cardMaskedNumber = paymentData.paymentMethodData.info.cardDetails
                    AmountCommission.countAmount();
                }, 500);
            } else {
                if($rootScope.servicePage) {
                    $scope.pay.confirmServicePayment(true);
                } else {
                    $scope.pay.createPayment(true);
                }
            }
        }).catch(function (err) {
            console.error('err payment ', err);
        });
    }
});



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/googlePay/directives/googlePay.js
 ** module id = 163
 ** module chunks = 1
 **/